import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    selectNumberFlag,
    selectNumberArray,
    selectNumberType,
    selectActiveBatPrice,
    selectRoundCardRender,
    selectRenderCardArray,
    setSelectNumberFlag,
    setNumberType,
    setRenderCardArray,
    setRoundCardRender,
    selectPanelWithInput,
    updatePanelWithInput,
    selectPointList,
    selectActiveDropDownValue,
    selectEnterQt,
    setActiveDropDownValue,
    setEnterQt,
    setPointList,
    selectTimeSloat3d,
    setActiveBatPrice
} from "../../../redux/3d_game_Slice/panelSlice";
import { selectPickTrNo, selectPickLastSaleAmount } from "../../../redux/3d_game_Slice/gameinfo3d";
import { generateGameNumbers } from "../common/NumberGenerateLogic";
import "./mainTable.scss";

import ShowHereAllNumber from "../common/ShowHereAllNumber";
import PrintComponent3d from "../common/PrintComponent3d";
import { selectAdvaceTimeSlotCount, selectTimeSlot, setLoaderShow } from "../../../redux/seriesSlice";
import { useNavigate } from "react-router-dom";
import { SocketState } from "../../../context/SocketProvider";
import { AuthState } from "../../../context/AuthProvider";

function MainTable3d() {
    const isMobile = /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i.test(navigator.userAgent);
    const [activeInput, setActiveInput] = useState("add");
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { socket } = SocketState();
    const { userDetail } = AuthState();
    let timeSlot = useSelector(selectTimeSloat3d);
    const selectNumbers = useSelector(selectNumberFlag);
    const numberArray = useSelector(selectNumberArray);
    const numberType = useSelector(selectNumberType);
    const activeBatPrice = useSelector(selectActiveBatPrice);
    const renderCardArray = useSelector(selectRenderCardArray);
    const renderCardArry = useSelector(selectRenderCardArray);
    const roundCardRender = useSelector(selectRoundCardRender);
    const betTypes = useSelector(selectPanelWithInput);
    const pointList = useSelector(selectPointList);
    const activeDropDownValue = useSelector(selectActiveDropDownValue);
    const enterQt = useSelector(selectEnterQt);
    const advaceTimeSlotCount = useSelector(selectAdvaceTimeSlotCount);
    const lastTicketId = useSelector(selectPickTrNo);
    const lastSaleAmount = useSelector(selectPickLastSaleAmount);
    let checkTimeSlots = useSelector(selectTimeSlot);

    const [addNumberInput, setAddNumberInput] = React.useState('');
    const [fromRange, setFromRange] = React.useState('');
    const [toRange, setToRange] = React.useState('');
    const [selectBetTypes, setSelectBetTypes] = React.useState([]);
    const [inputMaxLength, setInputMaxLength] = React.useState(0);
    const [disableFlag, setDisableFlag] = React.useState(false);
    const [selectAllFlag, setSelectAllFlag] = React.useState(false);
    const [selectAllBetTypes, setSelectAllBetTypes] = React.useState(false);
    const [selectedItems, setSelectedItems] = useState({
        all: false,
        0: true,
        1: false,
        2: false
    });

    const [showWhatsappPopup3d, setShowWhatsappPopup3d] = useState(false);
    const [mobileNumber, setMobileNumber] = useState("");

    React.useEffect(() => {
        // Ignore FAMILY in ALL check
        const allSelected = betTypes
            .filter(
                (type) => type.label?.toUpperCase() !== "FAMILY"
            )
            .every((type) => type.check);

        setSelectAllBetTypes(allSelected);
    }, [betTypes]);

    const seletAllBetCheck = (e) => {
        const checked = e.target.checked;

        const updateArray = betTypes.map((type) => ({
            ...type,
            check:
                type.label?.toUpperCase() === "FAMILY"
                    ? false
                    : checked,
        }));

        dispatch(updatePanelWithInput(updateArray));
    };

    useEffect(() => {
        if (selectNumbers.includes(true)) {
            setDisableFlag(true);
        } else {
            setDisableFlag(false);
        }
    }, [selectNumbers]);

    useEffect(() => {
        const filteredData =
            betTypes.filter(obj => obj.check);

        setSelectBetTypes(filteredData);

        // Ignore FAMILY for input length
        const playableTypes =
            filteredData.filter(
                item =>
                    item.label?.toUpperCase() !==
                    "FAMILY"
            );

        if (playableTypes.length) {
            const maxObj =
                playableTypes.reduce(
                    (max, obj) =>
                        max.maxLength >
                            obj.maxLength
                            ? max
                            : obj
                );

            setInputMaxLength(
                maxObj.maxLength
            );
        }
    }, [betTypes]);

    const handleKeyDown = (event) => {
        if ([38, 40, 189, 109, 107].includes(event.keyCode)) {
            event.preventDefault();
        }
    };

    const handleWheel = (event) => {
        event.preventDefault();
    };

    const handleAddNumberChangeSingle = (e) => {
        setAddNumberInput(e.target.value);
        if (e.target.value.length === inputMaxLength) {
            generateNumberCards(e.target.value);
        }
    };

    const handleAddNumberChange = (e) => {
        setAddNumberInput(e.target.value);
        if (e.target.value.length === inputMaxLength) {
            generateNumberCards(e.target.value);
        }
    };

    const generateNumberCards = (number) => {
        const splitNumber = number.split('');

        // A/B/C selected
        const selectedABC = Object.keys(selectedItems)
            .filter((key) => key !== "all" && selectedItems[key])
            .map((key) => mapping[key]);

        // Always get latest selected bet types
        const activeBetTypes = betTypes.filter(
            (type) => type.check
        );

        // FAMILY selected?
        const familySelected = activeBetTypes.some(
            (type) =>
                type.label?.toUpperCase() === "FAMILY"
        );

        // Remove FAMILY
        const playableBetTypes =
            activeBetTypes.filter(
                (type) =>
                    type.label?.toUpperCase() !==
                    "FAMILY"
            );

        const baseCardArray = [];

        playableBetTypes.forEach((betType) => {
            const numberIndexArray =
                betType.numberIndex.split('');

            let generatedNumber;

            if (inputMaxLength > 2) {
                generatedNumber =
                    numberIndexArray.map(
                        (index) =>
                            splitNumber[index]
                    );
            } else {
                generatedNumber =
                    splitNumber;
            }

            const pureNumber =
                generatedNumber.join('');

            let numbersToGenerate = [
                pureNumber,
            ];

            // FAMILY logic
            if (
                familySelected &&
                pureNumber.length === 2 &&
                ["SP", "FP", "BP", "AP"].includes(
                    betType.label?.toUpperCase()
                )
            ) {
                numbersToGenerate =
                    getFamilyNumbers(
                        pureNumber
                    );

                console.log(
                    "FAMILY GENERATED",
                    numbersToGenerate
                );
            }

            numbersToGenerate.forEach(
                (num) => {
                    baseCardArray.push({
                        pureNumber: num,
                        betType:
                            betType.label,
                        rateValue:
                            activeBatPrice,
                    });
                }
            );
        });

        const finalCardArray = [];

        baseCardArray.forEach((item) => {
            const prefixes =
                selectedABC.length
                    ? selectedABC
                    : ["A"];

            prefixes.forEach((prefix) => {
                finalCardArray.push({
                    number:
                        prefix +
                        item.pureNumber,
                    betType:
                        item.betType,
                    rateValue:
                        item.rateValue,
                });
            });
        });

        console.log(
            "FINAL",
            finalCardArray
        );

        if (roundCardRender) {
            dispatch(
                setRenderCardArray(
                    finalCardArray
                )
            );
            dispatch(
                setRoundCardRender(false)
            );
        } else {
            dispatch(
                setRenderCardArray([
                    ...renderCardArray,
                    ...finalCardArray,
                ])
            );
        }

        setAddNumberInput('');
    };

    const handleRangeChange = () => {
        if (
            fromRange.length === inputMaxLength &&
            toRange.length === inputMaxLength &&
            fromRange <= toRange
        ) {
            const cardArray = [];

            // STEP 1 → A / B / C list
            const selectedABC = Object.keys(selectedItems)
                .filter((key) => key !== "all" && selectedItems[key])
                .map((key) => mapping[key]); // {0:"A",1:"B",2:"C"}

            for (let index = fromRange; index <= toRange; index++) {
                const familySelected = selectBetTypes.some(
                    (type) => type.label?.toUpperCase() === "FAMILY"
                );

                const playableBetTypes = selectBetTypes.filter(
                    (type) => type.label?.toUpperCase() !== "FAMILY"
                );

                playableBetTypes.forEach((betType) => {
                    let splitNumber = index.toString().split('');
                    const numberIndexArray = betType.numberIndex.split('');
                    let number;

                    // FORMAT FIX
                    if (inputMaxLength > 2) {
                        if (splitNumber.length === 1) splitNumber.unshift(0, 0);
                        else if (splitNumber.length === 2) splitNumber.unshift(0);

                        number = numberIndexArray.map(idx => splitNumber[idx]);
                    } else {
                        if (splitNumber.length < 2) splitNumber.unshift(0);
                        number = splitNumber;
                    }

                    const pureNum = number.join('');

                    let numbersToGenerate = [pureNum];

                    if (
                        familySelected &&
                        ["SP", "FP", "BP", "AP"].includes(
                            betType.label?.toUpperCase()
                        )
                    ) {
                        numbersToGenerate =
                            getFamilyNumbers(pureNum);
                    }

                    // STEP 2 → A/B/C Prefix Logic
                    numbersToGenerate.forEach((familyNum) => {
                        if (selectedABC.length === 0) {
                            cardArray.push({
                                number: 'A' + familyNum,
                                betType: betType.label,
                                rateValue: activeBatPrice
                            });
                        } else {
                            selectedABC.forEach((prefix) => {
                                cardArray.push({
                                    number: prefix + familyNum,
                                    betType: betType.label,
                                    rateValue: activeBatPrice
                                });
                            });
                        }
                    });
                });
            }

            // FINAL update
            if (roundCardRender) {
                dispatch(setRenderCardArray(cardArray));
                dispatch(setRoundCardRender(false));
            } else {
                dispatch(setRenderCardArray([...renderCardArray, ...cardArray]));
            }

            setFromRange('');
            setToRange('');
        }
    };


    useEffect(() => {
        handleRangeChange()
    }, [fromRange, toRange])

    const handleSelectAll = () => {
        dispatch(setSelectNumberFlag([true, true, true, true, true, true, true, true, true, true]));
    };

    const handleNumberClick = (number) => {
        let copySelectNumbers = [...selectNumbers];
        copySelectNumbers[number] = !copySelectNumbers[number];
        dispatch(setSelectNumberFlag(copySelectNumbers));
    };

    const handleTypeChange = (typeIndex) => {
        let copyNumberType = JSON.parse(JSON.stringify(numberType));
        copyNumberType[typeIndex].check = !copyNumberType[typeIndex].check;
        dispatch(setNumberType(copyNumberType));
    };
    const getFamilyNumbers = (num) => {
        const number = num.toString().padStart(2, "0");

        const first = parseInt(number[0]);
        const second = parseInt(number[1]);

        const plusFiveFirst = (first + 5) % 10;
        const plusFiveSecond = (second + 5) % 10;

        return [...new Set([
            `${first}${second}`,
            `${second}${first}`,

            `${first}${plusFiveSecond}`,
            `${plusFiveSecond}${first}`,

            `${second}${plusFiveFirst}`,
            `${plusFiveFirst}${second}`,

            `${plusFiveFirst}${plusFiveSecond}`,
            `${plusFiveSecond}${plusFiveFirst}`,
        ])];
    };
    const generateLuckyPickNumber = () => {
        const numberOfDigits = Math.floor(Math.random() * 10) + 1;
        const numberArrayA = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
        let numbersArray = [];
        let copyNumberFlag = Array(10).fill(false);

        for (let i = 0; i < numberOfDigits; i++) {
            const lengthNumner = numberArrayA.length;
            const randomIndex = Math.floor(Math.random() * lengthNumner);

            copyNumberFlag[randomIndex] = true;
            numbersArray[i] = numberArrayA[randomIndex];

            numberArrayA.splice(randomIndex, 1);
        }

        dispatch(setSelectNumberFlag(copyNumberFlag));

        // STEP 1: yaha selectedABC nikalna
        const selectedABC = Object.keys(selectedItems)
            .filter((key) => key !== "all" && selectedItems[key])
            .map((key) => mapping[key]);

        // ✅ Default A if none selected
        if (!selectedABC.length) {
            selectedABC = ["A"];
        }


        const selectNumberType = numberType.filter(type => type.check).map(type => type.label);

        // STEP 2: selectedABC pass kar diya
        const generateArray = generateGameNumbers(
            numbersArray,
            selectNumberType,
            selectedABC,
            activeBatPrice,
        );

        dispatch(setRenderCardArray(generateArray));
        dispatch(setRoundCardRender(true));
    };

    const handleSubmitAddNumber = () => {
        const digit = String(addNumberInput).trim();

        if (!/^\d$/.test(digit)) {
            alert("Please enter one digit (0-9)");
            return;
        }

        const selectedABC = Object.keys(selectedItems)
            .filter((key) => key !== "all" && selectedItems[key])
            .map((key) => mapping[key]);

        const prefixes = selectedABC.length ? selectedABC : ["A"];
        const generatedCards = [];

        // FP, BP, SP tino ek saath
        const typesToGenerate = ["FP", "BP", "SP"];

        typesToGenerate.forEach((label) => {
            let numbers = [];

            if (label === "FP" || label === "BP") {
                // Example: 6 => 60, 61, 62 ... 69
                numbers = Array.from(
                    { length: 10 },
                    (_, i) => `${digit}${i}`
                );
            } else if (label === "SP") {
                // Example: 6 => 06, 16, 26 ... 96
                numbers = Array.from(
                    { length: 10 },
                    (_, i) => `${i}${digit}`
                );
            }

            numbers.forEach((number) => {
                prefixes.forEach((prefix) => {
                    generatedCards.push({
                        number: `${prefix}${number}`,
                        betType: label,
                        rateValue: activeBatPrice,
                    });
                });
            });
        });

        if (roundCardRender) {
            dispatch(setRenderCardArray(generatedCards));
            dispatch(setRoundCardRender(false));
        } else {
            dispatch(
                setRenderCardArray([
                    ...renderCardArray,
                    ...generatedCards,
                ])
            );
        }

        setAddNumberInput("");
    };

    const generateRoundNumber = () => {
        const selectNumber = [];

        numberArray.forEach((number) => {
            if (selectNumbers[number]) selectNumber.push(number);
        });

        if (!selectNumber.length) return;

        // A/B/C selected prefixes
        const selectedABC = Object.keys(selectedItems)
            .filter((key) => key !== "all" && selectedItems[key])
            .map((key) => mapping[key]); // mapping={0:"A",1:"B",2:"C"}

        // ✅ Default A if none selected
        if (!selectedABC.length) {
            selectedABC = ["A"];
        }

        // Selected bet types (SP, DP, etc.)
        const selectNumberType = numberType
            .filter(type => type.check)
            .map(type => type.label);

        if (!selectNumberType.length) return;

        const generated = generateGameNumbers(
            selectNumber,
            selectNumberType,
            selectedABC,
            activeBatPrice
        );

        dispatch(setRenderCardArray(generated));
        dispatch(setRoundCardRender(true));
    };



    // Handle individual checkbox clicks
    const handleCheckboxChange = (id) => {
        if (id === 'all') {
            const newState = {
                all: !selectedItems.all,
                0: !selectedItems.all,
                1: !selectedItems.all,
                2: !selectedItems.all
            };
            setSelectedItems(newState);
        } else {
            const newState = {
                ...selectedItems,
                [id]: !selectedItems[id],
                all: false // Uncheck "All" if any individual checkbox is changed
            };
            setSelectedItems(newState);
        }
    };

    // Handle button clicks (same as checkbox clicks)
    const handleButtonClick = (id) => {
        handleCheckboxChange(id);
    };

    // Handle Unique button click - truly random selection
    const handleUniqueClick = () => {
        setSelectedItems({
            all: false, // Never set 'all' directly from random
            0: Math.random() > 0.5, // 50% chance for A
            1: Math.random() > 0.5, // 50% chance for B
            2: Math.random() > 0.5  // 50% chance for C
        });
    };

    // Get button style based on selection state
    const getButtonStyle = (id) => {
        const baseStyle = {
            padding: "3px 10px",
            color: "#000",
            fontSize: "clamp(14px, 1.8vw, 20px)", // pass as string
            width: "100%",
            border: "1px solid #000",
            marginTop: "0px"
        };

        if (id === 'all') {
            return {
                ...baseStyle,
                background: selectedItems.all ? "#ff8100" : "#666666ff"
            };
        }

        const colorMap = {
            0: "#F8F8A2",
            1: "#eda3ba",
            2: "#a2ae1b"
        };

        return {
            ...baseStyle,
            background: selectedItems[id] ? "#ff8100" : colorMap[id]
        };
    };

    const [apiKey, setapiKey] = useState({
        Box: "box",
        STR: "straight",
        SP: "split_pair",
        FP: "front_pair",
        BP: "back_pair",
        AP: "any_two",
    });
    const mapping = { 0: "A", 1: "B", 2: "C" };
    const result = Object.keys(selectedItems)
        .filter((key) => key !== "all" && selectedItems[key])
        .map((key) => mapping[key])
        .join(",");

    let generateNumber = () => {
        let genrateNumber = Math.floor(Math.random() * (999 - 100 + 1) + 100);
        let generateObjNumber = {
            number: genrateNumber,
            betType: activeDropDownValue,
            rateValue: activeBatPrice,
        };
        return generateObjNumber;
    };

    const placeBat = () => {
        dispatch(setLoaderShow(true));

        let selectTimeFilter = [];
        JSON.parse(JSON.stringify(timeSlot)).forEach((time) => {
            if (time.select) {
                selectTimeFilter.push(time.time);
            }
        });

        let generateArray = [];

        for (let index = 0; index < enterQt; index++) {
            let obj = generateNumber();
            generateArray.push(obj);
        }

        let card_details = {};
        let mergeArray = [...renderCardArry, ...generateArray];
        mergeArray.forEach((card) => {
            const betTypeKey = apiKey[card.betType] || "straight";
            if (!card_details[betTypeKey]) {
                card_details[betTypeKey] = {};
            }

            if (card_details[betTypeKey][card.number]) {
                card_details[betTypeKey][card.number] += activeBatPrice;
            } else {
                card_details[betTypeKey][card.number] = activeBatPrice;
            }
        });

        const mobile_number = localStorage.getItem("mobile_number") ?? null;
        let data = {
            en: "PICK_THREE_PLACE_BET",
            data: {
                advance_bet: checkTimeSlots.length ? true : false,
                advance_bet_times: checkTimeSlots.length ? checkTimeSlots : "",
                card_details,
                // series_type: result,
                mobile_number,
            },
        };
        socket?.emit("req", data);
        localStorage.removeItem("mobile_number");
    };

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "F6") {
                event.preventDefault();
                placeBat();
            }
        };

        const handleWhatsappPlaceBet3d = () => {
            placeBat();
        };

        window.addEventListener("keydown", handleKeyDown);
        window.addEventListener("whatsappPlaceBet3d", handleWhatsappPlaceBet3d);

        return () => {
            window.removeEventListener("keydown", handleKeyDown);
            window.removeEventListener(
                "whatsappPlaceBet3d",
                handleWhatsappPlaceBet3d
            );
        };
    }, [placeBat]);

    const downHandler = useCallback((e) => {
        let { key, code } = e

        if (code === "Space") {
            e.preventDefault(); // page scroll stop
        }

        if (code === "Space") {
            navigate('claim-ticket-3d ');
        }
    }, [dispatch, navigate]);

    // Add the keydown event listener for F5, F6, etc.
    useEffect(() => {
        window.addEventListener("keydown", downHandler);

        return () => {
            window.removeEventListener("keydown", downHandler);
        }
    }, [downHandler]);

    return (
        <>
            <table width="100% !important" style={{ background: "#f5e3b5" }} id="abcTableId">
                <tbody>
                    <tr>
                        <td width="2%"></td>
                        <td width="1%" className="pt-2">
                            <input
                                type="checkbox"
                                id="abcCheckIdAll"
                                checked={selectedItems.all}
                                onChange={() => handleCheckboxChange('all')}
                                className="three-checkbox"
                            />
                        </td>
                        <td width="9%">
                            <button
                                type="button"
                                style={getButtonStyle('all')}
                                onClick={() => handleButtonClick('all')}
                            >
                                <span>ALL</span>
                            </button>
                        </td>
                        <td width="3%"></td>

                        {/* A Button */}
                        <td width="1%" className="pt-2">
                            <input
                                type="checkbox"
                                id="abcCheckId0"
                                checked={selectedItems[0]}
                                onChange={() => handleCheckboxChange('0')}
                                className="three-checkbox"
                            />
                        </td>
                        <td width="9%">
                            <button
                                type="button"
                                id="abcButtonId0"
                                style={getButtonStyle('0')}
                                onClick={() => handleButtonClick('0')}
                            >
                                <span>A</span>
                            </button>
                        </td>
                        <td width="1%"></td>

                        {/* B Button */}
                        <td width="1%" className="pt-2">
                            <input
                                type="checkbox"
                                id="abcCheckId1"
                                checked={selectedItems[1]}
                                onChange={() => handleCheckboxChange('1')}
                                className="three-checkbox"
                            />
                        </td>
                        <td width="9%">
                            <button
                                type="button"
                                id="abcButtonId1"
                                style={getButtonStyle('1')}
                                onClick={() => handleButtonClick('1')}
                            >
                                <span>B</span>
                            </button>
                        </td>
                        <td width="1%"></td>

                        {/* C Button */}
                        <td width="1%" className="pt-2">
                            <input
                                type="checkbox"
                                id="abcCheckId2"
                                checked={selectedItems[2]}
                                onChange={() => handleCheckboxChange('2')}
                                className="three-checkbox"
                            />
                        </td>
                        <td width="9%">
                            <button
                                type="button"
                                id="abcButtonId2"
                                style={getButtonStyle('2')}
                                onClick={() => handleButtonClick('2')}
                            >
                                <span>C</span>
                            </button>
                        </td>

                        <td width="20%" className="text-center">
                            <h6 style={{ marginBottom: "0px", padding: "8px", fontSize: "clamp(14px, 1.8vw, 20px)", }}>
                                L-Trans-ID: &nbsp;{lastTicketId},&nbsp;Pt( {lastSaleAmount} )&nbsp;
                            </h6>
                        </td>
                        {/* Unique Button */}
                        <td width="12.5%">
                            <center>
                                <a
                                    href="#"
                                    className="tag1"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleUniqueClick();
                                    }}
                                >
                                    <h5 style={{
                                        marginBottom: "0px",
                                        color: "#fff",
                                        background: "rgb(79 3 126)",
                                        fontSize: "clamp(14px, 1.8vw, 20px)", // pass as string
                                        padding: "4px"
                                    }}>
                                        Random
                                    </h5>
                                </a>
                            </center>
                        </td>
                    </tr>
                </tbody>
            </table>
            <table width="100% !important;" style={{ background: "#f4b36e" }} id="generatedAppId">
                <tbody>
                    <tr>
                        <td width="1%"></td>
                        <td width="35%" id="specialid51">
                            <span
                                style={{
                                    borderRadius: "30%",
                                    width: "20px",
                                    height: "20px",
                                    padding: "2px",
                                    background: selectAllFlag ? 'red' : 'white',
                                    border: selectAllFlag ? "2px solid red" : "2px solid rgb(102, 102, 102)",
                                    color: selectAllFlag ? 'white' : "rgb(102, 102, 102)",
                                    textAlign: "center",
                                    fontSize: "clamp(14px, 1.8vw, 20px)", // pass as string
                                    cursor: "pointer"
                                }}
                                id="numberWheelIdA"
                                onClick={() => {
                                    const newSelectAll = !selectAllFlag;
                                    setSelectAllFlag(newSelectAll);
                                    dispatch(setSelectNumberFlag(Array(10).fill(newSelectAll)));
                                }}
                            > All</span>

                            {numberArray.map(number => {
                                const selectNumber = selectNumbers[number];
                                return (
                                    <span
                                        key={number}
                                        style={{
                                            borderRadius: "30%",
                                            width: "20px",
                                            height: "20px",
                                            padding: "2px",
                                            background: selectNumber ? 'red' : 'white',
                                            border: selectNumber ? "2px solid red" : "2px solid rgb(102, 102, 102)",
                                            color: selectNumber ? 'white' : "rgb(102, 102, 102)",
                                            textAlign: "center",
                                            fontSize: "clamp(14px, 1.8vw, 20px)", // pass as string
                                            cursor: "pointer",
                                            marginLeft: "clamp(6px, 1vw, 5px)",
                                        }}
                                        id={`numberWheelId${number}`}
                                        onClick={() => {
                                            const newSelectNumbers = [...selectNumbers];
                                            newSelectNumbers[number] = !newSelectNumbers[number];
                                            dispatch(setSelectNumberFlag(newSelectNumbers));
                                            // Update selectAllFlag based on new selection
                                            setSelectAllFlag(newSelectNumbers.every(val => val));
                                        }}
                                    >
                                        &nbsp; {number}&nbsp;
                                    </span>
                                );
                            })}
                        </td>

                        {numberType.map((type, typeIndex) => (
                            <td width="8%" key={typeIndex}>
                                <input
                                    type="checkbox"
                                    checked={type.check || false} // Fallback to false if undefined
                                    style={{ fontSize: "clamp(14px, 1.8vw, 20px)", color: "#000" }}
                                    onChange={(e) => {
                                        e.stopPropagation();
                                        const updatedNumberType = numberType.map((item, idx) =>
                                            idx === typeIndex ? { ...item, check: !item.check } : item
                                        );
                                        dispatch(setNumberType(updatedNumberType));
                                    }}
                                    className="three-checkbox"
                                />
                                &nbsp;<i style={{ color: "#000", fontSize: "clamp(14px, 1.8vw, 20px)", }}><b>{type.label}</b></i>
                            </td>
                        ))}

                        <td width="8%">
                            <button
                                type="button"
                                onClick={generateRoundNumber}
                                style={{
                                    background: "#0d007e",
                                    border: "#ff8100",
                                    padding: "3px 10px",
                                    color: "#fff",
                                    fontSize: "clamp(14px, 1.8vw, 20px)",
                                    width: "100%",
                                    border: "#000 solid 1px",
                                    marginTop: "0px"
                                }}
                                disabled={!selectNumbers.includes(true)}
                            >
                                <span><b>Round</b></span>
                            </button>
                        </td>

                        <td width="8%">
                            <button
                                type="button"
                                onClick={generateLuckyPickNumber}
                                style={{
                                    background: "#a85602",
                                    border: "#ff8100",
                                    padding: "3px 10px",
                                    color: "#fff",
                                    fontSize: "clamp(14px, 1.8vw, 20px)",
                                    width: "100%",
                                    border: "#000 solid 1px",
                                    marginTop: "0px"
                                }}
                            >
                                <span><b>L-Pick</b></span>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
            <table width="100% !important;" style={{ background: "#f5e3b5" }}>
                <tbody>
                    <tr>
                        <td width="3%"></td>
                        <td width="65%" id="specialid5">
                            <input
                                type="checkbox"
                                checked={selectAllBetTypes}
                                onChange={seletAllBetCheck}
                                id="allCheckId"
                                className="three-checkbox"
                            />&nbsp;
                            <span style={{ color: "#000", fontSize: "clamp(14px, 1.8vw, 20px)", fontWeight: "600 !important", marginRight: "20px" }}>All</span>

                            {betTypes.map((betType, index) => (
                                <React.Fragment key={index}>
                                    <input
                                        type="checkbox"
                                        id={`gameTypeId${index + 1}`}
                                        checked={betType.check}
                                        onChange={(e) => {
                                            const checked = e.target.checked;
                                            const copyBatTypes = JSON.parse(JSON.stringify(betTypes));

                                            const clickedType = copyBatTypes[index];
                                            const label = clickedType.label?.toUpperCase();

                                            // Update clicked checkbox
                                            copyBatTypes[index].check = checked;

                                            const allowedWithFamily = ["SP", "FP", "BP", "AP"];

                                            // Find FAMILY index
                                            const familyIndex = copyBatTypes.findIndex(
                                                (item) => item.label?.toUpperCase() === "FAMILY"
                                            );

                                            // -------------------------
                                            // FAMILY LOGIC
                                            // -------------------------
                                            if (label === "FAMILY" && checked) {
                                                // Only uncheck invalid types
                                                copyBatTypes.forEach((item) => {
                                                    const itemLabel = item.label?.toUpperCase();

                                                    if (
                                                        itemLabel !== "FAMILY" &&
                                                        !allowedWithFamily.includes(itemLabel)
                                                    ) {
                                                        item.check = false;
                                                    }
                                                });

                                                // ❌ REMOVED AUTO SELECT OF SP FP BP AP
                                                // User can freely choose any one or multiple
                                            }

                                            // -------------------------
                                            // IF NON-ALLOWED TYPE SELECTED
                                            // WHILE FAMILY IS ACTIVE
                                            // -------------------------
                                            const familySelected =
                                                familyIndex !== -1 &&
                                                copyBatTypes[familyIndex].check;

                                            if (
                                                familySelected &&
                                                !allowedWithFamily.includes(label) &&
                                                label !== "FAMILY"
                                            ) {
                                                // Uncheck FAMILY automatically
                                                copyBatTypes[familyIndex].check = false;
                                            }

                                            // -------------------------
                                            // IF ALL BET TYPES SELECTED
                                            // FAMILY OFF
                                            // -------------------------
                                            const allSelectedExceptFamily = copyBatTypes
                                                .filter(
                                                    (item) => item.label?.toUpperCase() !== "FAMILY"
                                                )
                                                .every((item) => item.check);

                                            if (allSelectedExceptFamily && familyIndex !== -1) {
                                                copyBatTypes[familyIndex].check = false;
                                            }

                                            dispatch(updatePanelWithInput(copyBatTypes));
                                        }}
                                        className="three-checkbox"
                                    />
                                    <span style={{ color: "#000", fontSize: "clamp(14px, 1.8vw, 20px)", fontWeight: "600 !important", marginRight: "20px" }}>
                                        &nbsp;{betType.label}&nbsp;&nbsp;&nbsp;
                                    </span>
                                </React.Fragment>
                            ))}
                        </td>
                        <td>
                            <tr>
                                <td>
                                    <input
                                        type="number"
                                        style={{
                                            display: "block",
                                            margin: "2px",
                                            height: "calc(1.75em + 0.75rem + 2px)",
                                            textAlign: "center",
                                            color: "red",
                                            fontWeight: "700",
                                            border: "#0015de solid 2px",
                                            borderRadius: "30px",
                                            padding: "0px",
                                            fontSize: "clamp(14px, 1.3vw, 20px)",
                                        }}
                                        id="spotthreeinoneid"
                                        placeholder="ADD NUMBER"
                                        className="form-control border-radiusImportant your_class"
                                        value={addNumberInput}
                                        onChange={(e) => {
                                            const value = e.target.value;

                                            // Sirf ek digit (0–9) allow hogi
                                            if (/^\d?$/.test(value)) {
                                                setAddNumberInput(value);
                                            }
                                        }}
                                        readOnly={isMobile}
                                        onKeyDown={handleKeyDown}
                                        onClick={() => isMobile && setActiveInput("add")}
                                        onWheel={handleWheel}
                                        disabled={disableFlag}
                                        autoComplete="off"
                                        min="0"
                                    />
                                </td>

                                <td>
                                    <button
                                        type="button"
                                        onClick={handleSubmitAddNumber}
                                        style={{
                                            background: "#0d007e",
                                            border: "#000 solid 1px",
                                            padding: "3px 10px",
                                            color: "#fff",
                                            fontSize: "clamp(14px, 1.8vw, 20px)",
                                            marginLeft: "5px",
                                            borderRadius: "5px",
                                            cursor: "pointer",
                                        }}
                                        disabled={
                                            !addNumberInput.trim() ||
                                            !betTypes.some((type) => type.check) ||
                                            disableFlag
                                        }
                                    >
                                        <span><b>Submit</b></span>
                                    </button>
                                </td>
                            </tr>
                        </td>
                    </tr>
                </tbody>
            </table>
            <table width="100%;" style={{ background: "#f4b36e" }}>
                <tbody>
                    <tr>
                        {/* <td width="0.5%;" id="allselectionId" style={{ visibility: "hidden" }}>
                                <select className="form-control" id="allselect" style={{ border: "#000 solid 1px" }}>
                                    <option disabled>All Selection</option>
                                    <option value="2">Box</option>
                                    <option value="1">STR</option>
                                    <option value="3">SP</option>
                                    <option value="4">FP</option>
                                    <option value="5">BP</option>
                                    <option value="6">AP</option>
                                </select>
                            </td> */}
                        <td width="0.5%;" id="specialid1"></td>
                        <td width="13%;" id="specialid2">
                            <input
                                type="number"
                                style={{
                                    display: "block",
                                    width: "100%",
                                    margin: "2px",
                                    height: "calc(1.75em + 0.75rem + 2px) !important",
                                    textAlign: "center",
                                    color: "red !important",
                                    fontWeight: "700",
                                    border: "#0015de solid 2px",
                                    borderRadius: "30px !important",
                                    padding: "0px !important",
                                    fontSize: "clamp(14px, 1.3vw, 20px)",
                                }}
                                id="spotthreeinoneid"
                                placeholder="ADD NUMBER"
                                className="form-control border-radiusImportant your_class"
                                value={addNumberInput}
                                onChange={!isMobile ? handleAddNumberChange : undefined}
                                readOnly={isMobile}
                                onKeyDown={handleKeyDown}
                                onClick={() => isMobile && setActiveInput("add")}
                                onWheel={handleWheel}
                                disabled={disableFlag}
                                autoComplete="off"
                                min="1"
                            />
                        </td>

                        <td width="1%;" id="specialid3"></td>
                        <td width="4%;">
                            <h5 style={{ color: "#000", marginBottom: "0px", fontWeight: "700" }}>Range:</h5>
                        </td>
                        <td width="6%;" id="specialid4">
                            <input
                                type="number"
                                style={{
                                    textAlign: "center",
                                    color: "red !important",
                                    fontWeight: "700",
                                    border: "#0015de solid 2px",
                                    borderRadius: "20px !important",
                                    padding: "0px !important",
                                    fontSize: "clamp(12px, 1.3vw, 20px)",
                                }}
                                id="spotthreeinoneid1"
                                placeholder="NUM."
                                className="form-control border-radiusImportant g7 your_class"
                                value={fromRange}
                                onClick={() => isMobile && setActiveInput("from")}
                                onChange={(e) => {
                                    if (e.target.value.length <= inputMaxLength) {
                                        setFromRange(e.target.value)
                                    }
                                }}
                                onKeyDown={handleKeyDown}
                                onWheel={handleWheel}
                                disabled={disableFlag}
                                autoComplete="off"
                                min="1"
                                readOnly={isMobile}
                            />
                        </td>
                        <td width="1%;">
                            <center><h5 style={{ color: "#000", marginBottom: "0px" }}>To</h5></center>
                        </td>
                        <td width="6%;" id="specialid6">
                            <input
                                type="number"
                                style={{
                                    textAlign: "center",
                                    color: "red !important",
                                    fontWeight: "700",
                                    border: "#0015de solid 2px",
                                    borderRadius: "20px !important",
                                    padding: "0px !important",
                                    fontSize: "clamp(12px, 1.3vw, 20px)",
                                }}
                                onClick={() => isMobile && setActiveInput("to")}
                                id="spotthreeinoneid2"
                                placeholder="NUM."
                                className="form-control border-radiusImportant g7 your_class"
                                value={toRange}
                                autoComplete="off"
                                onChange={(e) => {
                                    if (e.target.value.length <= inputMaxLength) {
                                        setToRange(e.target.value)
                                    }
                                }}
                                readOnly={isMobile}
                                disabled={disableFlag}
                                onKeyDown={handleKeyDown}
                                onWheel={handleWheel}
                                min="1"
                            />
                        </td>

                        {isMobile ? "" :
                            <>
                                <td width="3%;">
                                    <h5 style={{ color: "#000", marginBottom: "0px", fontWeight: "700", textAlign: "right" }}>L-P:</h5>
                                </td>
                                <td width="8%">
                                    <select
                                        className="form-control id_100"
                                        id="luckypicktyype"
                                        value={activeDropDownValue}
                                        onChange={(e) => dispatch(setActiveDropDownValue(e.target.value))}
                                        style={{
                                            border: "#000 solid 1px",
                                            fontSize: "clamp(14px, 1.5vw, 20px)", color: "#000", border: "#000 solid 2px", padding: "0px !important"
                                        }}
                                        disabled={disableFlag}
                                    >
                                        <option value="Box" selected={activeDropDownValue === "Box"}>Box</option>
                                        <option value="STR" selected={activeDropDownValue === "STR"}>STR</option>
                                    </select>
                                </td>
                                <td width="8%;">
                                    <input
                                        type="text"
                                        id="luckypickidd"
                                        placeholder="Enter Qt."
                                        className="form-control your_class"
                                        value={enterQt}
                                        onChange={(e) => dispatch(setEnterQt(e.target.value))}
                                        onKeyDown={handleKeyDown}
                                        onWheel={handleWheel}
                                        disabled={disableFlag}
                                        style={{
                                            border: "#000 solid 1px", color: "#000 !important", fontWeight: "700 !important", border: "#000 solid 2px", padding: "5px !important",
                                            fontSize: "clamp(14px, 1.5vw, 20px)",
                                        }}
                                    />
                                </td></>
                        }
                        <td width="1%"></td>
                        <td width="3%" style={{
                            fontSize: "clamp(14px, 1.8vw, 20px)", color: "#000", fontWeight: "700"
                        }}>Rate:</td>
                        {pointList.map((point) => (
                            <td key={point.id} width={point.label === 200 ? "3.5%" : "3%"} style={{
                                fontSize: "clamp(12px, 1.3vw, 20px)", color: "#000", fontWeight: "700"
                            }}>
                                <input
                                    type="radio"
                                    id={`addreadonlyid1${point.id + 1}`}
                                    name="ratename"
                                    checked={point.check}
                                    onChange={() => {
                                        const updatedPoints = pointList.map(p => ({
                                            ...p,
                                            check: p.id === point.id
                                        }));
                                        dispatch(setPointList(updatedPoints));
                                        dispatch(setActiveBatPrice(point.label));
                                    }}
                                />&nbsp;{point.label}
                            </td>
                        ))}
                    </tr>
                </tbody>
            </table>
            <div
                className={isMobile ? "" : "mobile-screen"}
                style={{
                    display: "flex",
                    border: "3px solid #666",
                    background: "#f5e3b5",
                }}
            >
                {/* 80% Area */}
                <div
                    style={{
                        width: isMobile ? "80%" : "100%",
                        overflowY: "auto",
                        padding: "5px",
                        boxSizing: "border-box"
                    }}
                >
                    <ShowHereAllNumber isMobile={isMobile} />
                </div>

                {/* 20% Mobile Keypad */}
                {isMobile && (
                    <div className="mobile-keypad">

                        {['1', '2', '3', '4', '5', '6', '7', '8', '9', 'C', '0'].map((num, index) => (
                            <button
                                key={index}
                                className="key-btn"
                                onClick={() => {

                                    if (num === "C") {
                                        if (activeInput === "add") setAddNumberInput("");
                                        if (activeInput === "from") setFromRange("");
                                        if (activeInput === "to") setToRange("");
                                        return;
                                    }

                                    if (activeInput === "add") {
                                        const newValue = addNumberInput + num;

                                        if (newValue.length <= inputMaxLength) {
                                            setAddNumberInput(newValue);

                                            if (newValue.length === inputMaxLength) {
                                                generateNumberCards(newValue);
                                            }
                                        }
                                    }

                                    if (activeInput === "from") {
                                        const newValue = fromRange + num;
                                        if (newValue.length <= inputMaxLength) {
                                            setFromRange(newValue);
                                        }
                                    }

                                    if (activeInput === "to") {
                                        const newValue = toRange + num;
                                        if (newValue.length <= inputMaxLength) {
                                            setToRange(newValue);
                                        }
                                    }

                                }}
                            >
                                {num}
                            </button>
                        ))}
                    </div>
                )}

            </div>
            <table width="100%" style={{ marginTop: "0px" }}>
                <tbody>
                    <tr>
                        {userDetail?.auto_claim == false && (
                            <td width="10%">
                                <center>
                                    <button type="submit" class="font2 btn-hover  color-16 btn33" id="myBtn" onClick={() => navigate('claim-ticket-3d')} style={{
                                        width: "100%", background: "#FF9900",
                                        fontSize: "clamp(14px, 1.5vw, 20px)", padding: "6px", height: "50px", color: "black"
                                    }}><span className="font-bold">Claim</span>
                                    </button>
                                </center>
                            </td>)}
                        <td width="10%">
                            <center>
                                <button type="submit" class="font2 btn-hover color-16 btn33" id="myBtn" onClick={() => {
                                    socket.emit('req', {
                                        en: "LOTTARY_CLOSE_GAME",
                                        data: {}
                                    });
                                    navigate("/2d");
                                    localStorage.setItem("gameRoute", "2d")
                                }} style={{
                                    width: "100%", background: "#a5af1c",
                                    fontSize: "clamp(14px, 1.5vw, 20px)", padding: "6px", height: "50px", color: "black"
                                }}><span className="font-bold"> 4D</span>
                                </button>
                            </center>
                        </td>
                        <td width="10%">
                            <center>
                                <button type="submit" class="font2 btn-hover color-16 btn33" id="myBtn" onClick={() => {
                                    socket.emit('req', {
                                        en: "LOTTARY_CLOSE_GAME",
                                        data: {}
                                    });
                                    localStorage.setItem("gameRoute", "1d")
                                }} style={{
                                    width: "100%", background: "#eda3ba",
                                    fontSize: "clamp(14px, 1.5vw, 20px)", padding: "6px", height: "50px", color: "black"
                                }}><span className="font-bold"> 2D</span>
                                </button>
                            </center>
                        </td>

                        {/* <td width="10%">
                            <center>
                                <button type="submit" class="font2 btn-hover color-16 btn33" id="myBtn" onClick={() => {
                                    localStorage.setItem("gameRoute", "pana")
                                    navigate('/pana-game')
                                }} style={{
                                    width: "100%", background: "#d65d16",
                                    fontSize: "clamp(14px, 1.5vw, 20px)", padding: "6px", height: "50px", color: "black"
                                }}><span className="font-bold"> Pana</span>
                                </button>
                            </center>
                        </td> */}
                        {/* <td width="10%">
                                <center>
                                    <button type="submit" class="font2 btn-hover color-16 btn33" id="myBtn" onClick={() => {
                                        socket.emit('req', {
                                            en: "LOTTARY_CLOSE_GAME",
                                            data: {}
                                        });
                                        localStorage.setItem("gameRoute", "Titli")
                                    }} style={{
                                        width: "100%", background: "#f0a2d2",
                                        fontSize: "clamp(14px, 1.5vw, 20px)", padding: "6px", height: "50px", color: "black"
                                    }}><span className="font-bold"> TITLI</span>
                                    </button>
                                </center>
                            </td> */}
                        <td width="20%">
                            <input
                                type="text"
                                className="form-control"
                                style={{
                                    border: "#000 solid 1px",
                                    fontSize: "clamp(14px, 1.5vw, 20px)", color: "#000 !important", fontWeight: "700 !important", height: "40px !important",
                                }}
                                placeholder="Points"
                                disabled=""
                                // {advaceTimeSlotCount ? advaceTimeSlotCount * totalValue : totalValue}
                                value={
                                    ((renderCardArray.length + (enterQt ? +enterQt : 0)) *
                                        activeBatPrice *
                                        (advaceTimeSlotCount ? advaceTimeSlotCount : 1))
                                }
                            // value={((renderCardArray.length + (enterQt ? +enterQt : 0)) * activeBatPrice) * (advaceTimeSlotCount ? advaceTimeSlotCount : 1)} 
                            />
                        </td>

                        {userDetail?.whatsapp && (
                            <th
                                width="5%"
                                bordercolor="#FFFFFF"
                                scope="col"
                                style={{
                                    width: "10%", height: "40px", background: "#00FF00",
                                    border: " #000 solid 1px"
                                }}
                                onClick={() => setShowWhatsappPopup3d(true)}
                            >
                                Whatsapp
                            </th>)}
                        {userDetail?.user_bet && (
                            <th
                                width="5%"
                                bordercolor="#FFFFFF"
                                scope="col"
                                style={{
                                    width: "10%", height: "40px", background: "#a5af1c",
                                    border: " #000 solid 1px", color: '#fff'
                                }}
                                onClick={() => placeBat()}
                            >
                                Bet
                            </th>)}
                        {userDetail?.print && (
                            <td width="20%">
                                <PrintComponent3d selectedItems={selectedItems} />
                            </td>)}

                    </tr>
                </tbody>
            </table>
            {showWhatsappPopup3d && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0,0,0,0.6)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 9999,
                    }}
                >
                    <div
                        style={{
                            background: "#fff",
                            padding: "20px 30px",
                            borderRadius: "10px",
                            boxShadow: "0 0 15px rgba(0,0,0,0.3)",
                            width: "300px",
                            textAlign: "center",
                        }}
                    >
                        <h3 style={{ marginBottom: "15px" }}>Enter Mobile Number</h3>
                        <input
                            type="tel"
                            placeholder="Enter mobile number"
                            value={mobileNumber}
                            onChange={(e) => {
                                const value = e.target.value
                                if (value.length > 10) {
                                    alert("Mobile number must be 10 digits only")
                                    return
                                }
                                if (/^\d*$/.test(value)) {
                                    setMobileNumber(value)
                                }
                            }}
                            style={{
                                width: "100%",
                                padding: "8px",
                                borderRadius: "5px",
                                border: "1px solid #ccc",
                                marginBottom: "15px",
                            }}
                        />
                        <div style={{ display: "flex", justifyContent: "space-around" }}>
                            <button
                                style={{
                                    backgroundColor: "#28a745",
                                    color: "#fff",
                                    border: "none",
                                    padding: "8px 12px",
                                    borderRadius: "5px",
                                    cursor: "pointer",
                                }}
                                onClick={() => {
                                    if (mobileNumber.trim().length < 10) {
                                        alert("Please enter a valid mobile number");
                                        return;
                                    }
                                    localStorage.setItem("mobile_number", mobileNumber);

                                    // Call PlaceBat2d directly
                                    const printEvent = new Event("whatsappPlaceBet3d");
                                    window.dispatchEvent(printEvent);

                                    setShowWhatsappPopup3d(false);
                                    setMobileNumber("");
                                }}
                            >
                                Submit
                            </button>
                            <button
                                style={{
                                    backgroundColor: "#dc3545",
                                    color: "#fff",
                                    border: "none",
                                    padding: "8px 12px",
                                    borderRadius: "5px",
                                    cursor: "pointer",
                                }}
                                onClick={() => {
                                    setShowWhatsappPopup3d(false);
                                    setMobileNumber("");
                                }}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default MainTable3d;
